/**
 * Sb сохращенно Searchbar
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {BodyMode} from "base/assets/js/widget/BodyMode.js";
export class Sb extends Widget{

	_oState = {};
	bSearch = true;
	_oXhr;
	_iTimeout;
	/**
	 * @type {string} строка, к которой загружены подсказки с сервера
	 */
	_sBodyTerm = '';

	oMods = {
		loading: 'header_sb-loading',
		ready: 'header_sb-ready',
	};

	run() {
		this._my( { state: 'js:_oState' } );
		this._on( 'Term', 'click', () => {
			this.active();
		} );
		this._on( 'Reset?', 'click', () => {
			this.reset();
		} );
		this._on( 'ActiveBtn?', 'click', () => {
			this.active();
		} );
		this._on( 'Term', 'keyup', ::this.timeoutUpdate );
	}

	setBodyMode() {
		this._getBodyMode().setMode( 'body_searchbar', true );
	}

	setTerm( sTerm ) {
		this._el( 'Term' ).value = sTerm;
	}

	active() {
		if( this._el( 'Term' ).value !== this._sBodyTerm ) {
			this.update().then( () => {
				this.setBodyMode();
				this.focus();
			} )
		} else {
			this.setBodyMode();
			this.focus();
		}
	}

	focus() {
		this._el( 'Term' ).focus();
	}

	reset() {
		this._el( 'Term' ).value = '';
		return this.update();
	}

	update() {
		this.state( 'loading' );
		return this._fetch().then( ( sHtml ) => {
			this._unlink( this._el( 'Body' ) );
			this._el( 'Body' ).innerHTML = sHtml;
			return this._link( this._el( 'Body' ) ).then( () => {
				this._sBodyTerm = this._el( 'Term' ).value;
				return this.state( 'ready' );
			} )
		} );
	}

	_fetch() {
		return new Promise( ( fnResolve, fnReject ) => {
			if( this._oXhr ) {
				this._oXhr.abort();
			}
			this._oXhr = new XMLHttpRequest();
			let oXhr = this._oXhr;
			oXhr.onreadystatechange = () => {
				if( oXhr.readyState !== 4 ) {
					return;
				}
				fnResolve( oXhr.responseText );
			};
			oXhr.open( 'POST', '/search/searchbar', true );
			const oFormData = new FormData();
			this._oState.term = this._el( 'Term' ).value;
			oFormData.append( 'sState', JSON.stringify( this._oState ) );
			oXhr.send( oFormData );
		} );
	}

	timeoutUpdate() {
		if( this._iTimeout ) {
			window.clearTimeout( this._iTimeout );
		}
		this._iTimeout = window.setTimeout( ::this.update, 800 );
	}

	state( sState ) {
		this._mod( '', this.oMods, sState );
	}

	/**
	 * @return {BodyMode}
	 */
	_getBodyMode() {
		if( !this._oBodyMode ) {
			this._oBodyMode = this._rel().typeOf( BodyMode ).find();
		}
		return this._oBodyMode;
	}
}
